import { Skeleton } from "@/components/ui/Skeleton";

interface SkeletonTableProps {
  rows?: number;
  columns?: number;
}

/**
 * Renders a table-shaped skeleton — gray animated bars sized to suggest
 * the columns/rows about to load, rather than a generic centered spinner.
 * Used by pages with tabular data (Signals, Dashboard recent signals)
 * while their query is in flight.
 */
export function SkeletonTable({ rows = 5, columns = 5 }: SkeletonTableProps) {
  return (
    <table className="data-table" aria-hidden="true">
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <td key={colIndex}>
                <Skeleton height="0.875rem" width={colIndex === 0 ? "70%" : "50%"} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
